// extracted by mini-css-extract-plugin
export default {"Display":"ProfileDisplay_Display__Lea8d","Separator":"ProfileDisplay_Separator__ENaPG"};